var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarBiggest = function SvgStarBiggest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 49 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00CCBC",
    d: "m24.494.772 6.928 17.566 17.565 6.928-17.565 6.928-6.928 17.566-6.928-17.566L0 25.266l17.566-6.928z"
  })));
};
export { SvgStarBiggest as ReactComponent };
export default __webpack_public_path__ + "fonts/star-biggest-4e9e8590ebe5fad1e0df611502594d59.svg";